import React from 'react'
import { observer } from 'mobx-react-lite'
import { useNavigate, useParams } from 'react-router-dom'
import ProductCard from '../../components/ProductCard/ProductCard'
import './styles/Materials.scss'
import { apiClient } from '../../service/ApiClient'
import { Location } from '../../types/models/Locations'
import { Material } from '../../types/models/Material'
import { Button } from '@mui/material'
import CreateOrder from '../../components/modals/CreateOrder'
import RootStore from '../../store/RootStore'

type Props = {
  basePath?: string;
}

type Data = {
  childLocations: Location[]
  materials: Material[]
  locationId: number | undefined | null
  parrentId: number | undefined | null
  pathToMain: string | null
}

const Materials = observer((props: Props) => {
  const { basePath = '/materials' } = props;
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const [data, setData] = React.useState<Data>();
  const defaultLocation = RootStore.settingsStore.locationId;

  const orders = RootStore.userAction.orders

  const hundleFetch = React.useCallback(
    async (id: string | number | undefined) => {
      try {
        if (id || defaultLocation) {
          const allMaterials = await apiClient.get('/materials');
          const { data } = await apiClient.get(`/location/${id ? id : defaultLocation}`) ;
           
          if(data){
            if(data.materials){
              try {
                  // console.log('allMaterials: ', allMaterials);
                  const unitsMap = new Map();
                  //@ts-ignore
                  allMaterials.data.forEach(item => {
                    unitsMap.set(item.id, item.units);
                  });
                  
                  //@ts-ignore
                  data.materials.forEach(item => {
                    item.units = unitsMap.get(item.id);
                  });
              } catch (error) {
                console.error(error);
                setTimeout(() => {
                  // hundleFetch(id)
                }, 3000)
              }
            }

            const pathToMain = data.pathToMain
            ? `${data.pathToMain} → ${data.name}`
            : data.name

            RootStore.userAction.setCurrentPath(pathToMain)
            setData({
              childLocations: [], //data.child,
              materials: data.materials,
              locationId: data.id,
              parrentId: data.parrentId,
              pathToMain,
            })
          } else {
            const { data } = await apiClient.get(`/location`)
            RootStore.userAction.setCurrentPath(null)
            setData({
              childLocations: data,
              materials: [],
              locationId: null,
              parrentId: null,
              pathToMain: null,
            })
          }
          
        } else {
          const { data } = await apiClient.get(`/location`)
          RootStore.userAction.setCurrentPath(null)
          setData({
            childLocations: data,
            materials: [],
            locationId: null,
            parrentId: null,
            pathToMain: null,
          })
        }
      } catch (error) {
        setTimeout(() => {
          hundleFetch(id)
        }, 3000)
      }
    },
    [defaultLocation]
  )

  React.useEffect(() => {
    hundleFetch(id)
  }, [hundleFetch, id])

  const hundleNewOrder = (id: number | string, path?: string) => {
    const material = materials.find((m) => m.id === id)
    console.log(material?.units)
    const pathToMain = path?.substring(0, path?.lastIndexOf(' → '))
    const locationName = path?.substring(path?.lastIndexOf(' → ')+3)
    console.log(`Location: ${path}|${pathToMain}|${locationName}|`)
    console.log(RootStore.locationStore.getAll(true))
    console.log(data?.locationId)
    RootStore.modalsUi.hundleCreateOrder(true, material, path)
  }

  if (!data)
    return (
      <div className="Home-content">
        <p>Загрузка...</p>
      </div>
    )

  const { childLocations, materials, locationId, parrentId, pathToMain } = data

  return (
    <div className="Materials">
      <div className="Materials-filters">
        <div className="Materials-filters-content">
          {id !== '123' && id !== defaultLocation ? (
            <Button
              className="Materials-filters-content-button"
              onClick={() => {
                navigate(parrentId ? `${basePath}/${parrentId}` : `${basePath}`)
              }}
            >
              Назад
            </Button>
          ) : (
            ''
          )}
          <div className="Materials-filters-content-path">{pathToMain}</div>
        </div>
      </div>
      <div className="Materials-layout">
        <div className="Materials-content">
          {materials?.length === 0 && childLocations?.length === 0
            ? 'Ничего нет'
            : null}
          {childLocations?.map((locate) => {
            const currentOrders = orders?.filter((order) => {
              const path = locate.pathToMain
                ? `${locate.pathToMain} → ${locate.name}`
                : locate.name
              return order.locationPath?.includes(path)
            })
            return (
              <ProductCard
                key={locate.id}
                onClick={(e: any) => {
                  e.preventDefault()
                  navigate(`${basePath}/${locate.id}`)
                }}
                title={locate.name}
                type="folder"
                currentIssues={currentOrders?.length}
              />
            )
          }) ?? <p>Загрузка...</p>}
          {materials.map((material) => {
            return (
              <ProductCard
                key={material.id}
                onClick={() => {
                  hundleNewOrder(material.id, pathToMain ? pathToMain : undefined)
                  console.log(pathToMain)
                }}
                title={material.name}
                type="item"
              />
            )
          })}
        </div>
      </div>
      <CreateOrder />
    </div>
  )
})

export default Materials
